/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface EmploymentConditionLibraryAttributesEntityDataSourceModel {
  id?: string;
  dataSource: EmploymentConditionLibraryAttributesEntityDataSourceModelDataSourceEnum;
  mappingField?: string | null;
  sourceField?: string | null;
}
export enum EmploymentConditionLibraryAttributesEntityDataSourceModelDataSourceEnum {
  Chcm = 'CHCM',
  NewHire = 'NewHire',
  Are = 'Are',
  Mercer = 'Mercer',
  PermanentEstablishment = 'PermanentEstablishment',
  Location = 'Location',
  ExchangeRate = 'ExchangeRate',
  Virtual = 'Virtual'
}
